import { hasCapability, type User } from "../base";

export const market = {
  update: (user: User) => hasCapability(user, "market.update"),
  create: (user: User) => hasCapability(user, "market.create"),
  read: (user: User) => hasCapability(user, "market.read"),
};
